var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dynamic-page-renderer',{attrs:{"page":_vm.definition}})}
var staticRenderFns = []

export { render, staticRenderFns }